import { render, staticRenderFns } from "./AdminAboutYou.vue?vue&type=template&id=f994abc4&scoped=true"
import script from "./AdminAboutYou.vue?vue&type=script&lang=js"
export * from "./AdminAboutYou.vue?vue&type=script&lang=js"
import style0 from "./AdminAboutYou.vue?vue&type=style&index=0&id=f994abc4&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f994abc4",
  null
  
)

export default component.exports